import dayjs from "dayjs";
import React from "react";
import { Badge } from "reactstrap";

const getDaysArr = (period) => {
  const daysArray = [];

  if (!dayjs(period).isValid()) return daysArray;

  const firstDayOfMonth = dayjs(period).startOf("month");
  const daysInMonth = dayjs(period).daysInMonth();

  for (let day = 1; day <= daysInMonth; day++) {
    const date = firstDayOfMonth.date(day).format("YYYY-MM-DD");
    daysArray.push({ date, day });
  }

  return daysArray;
};

const getDatesMap = (salidas) => {
  const salidasMapper = {};

  salidas.forEach(({ salida_date }) => (salidasMapper[salida_date] = true));

  return salidasMapper;
};

const Calendar = ({ period, salidas }) => {
  const salidasMap = getDatesMap(salidas);
  const daysArray = getDaysArr(period);

  return (
    <div>
      <div className="d-flex flex-wrap">
        {daysArray.map(({ day, date }) => {
          const dateMatches = salidasMap[date] || false;
          return (
            <Badge 
              key={day}
              className="me-1 mb-1"
              style={{minWidth: "22px"}}
              color={`${dateMatches ? "success" : "light"}`}>
                {day}
            </Badge>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;

/* <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                  20 <span className="visually-hidden">unread messages</span>
                </span> */
